import { render, staticRenderFns } from "./edit-wrapper.vue?vue&type=template&id=144f059f"
import script from "./edit-wrapper.vue?vue&type=script&lang=ts"
export * from "./edit-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./edit-wrapper.vue?vue&type=style&index=0&id=144f059f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports